import { Action, QueryState } from '@/legacy/utils/reactHelpers';

enum ActionType {
  AdvanceStep = 'AdvanceStep',
  RegressStep = 'RegressStep',
  SetStep = 'SetStep',
  QuerySubmitCode = 'QuerySubmitCode',
  QueryClosePopup = 'QueryClosePopup',
  QueryClearInput = 'QueryClearInput',
}

enum LoginStep {
  ChooseProvider,
  VerifyAuthenticator,
}

interface State extends QueryState<ActionType> {
  step: LoginStep;
}

function getInitialState(): State {
  return {
    step: LoginStep.ChooseProvider,
    queries: [],
  };
}

function reducer(state: State, action: Action<ActionType>): State {
  switch (action.type) {
    case ActionType.AdvanceStep: {
      if (state.step === LoginStep.VerifyAuthenticator) {
        return {
          ...state,
          queries: [
            {
              type: ActionType.QuerySubmitCode,
            },
          ],
        };
      }

      return {
        ...state,
        step: state.step + 1,
      };
    }

    case ActionType.RegressStep: {
      if (state.step === LoginStep.ChooseProvider) {
        return {
          ...state,
          queries: [
            {
              type: ActionType.QueryClosePopup,
            },
          ],
        };
      }

      return {
        ...state,
        step: state.step - 1,
        queries: [
          {
            type: ActionType.QueryClearInput,
          },
        ],
      };
    }

    case ActionType.SetStep:
      return {
        ...state,
        step: action.payload,
      };

    default:
      return { ...state };
  }
}

export default reducer;
export type { State };
export { ActionType, LoginStep, getInitialState };
